import ControlViewModel from '@/ViewModels/ControlViewModel';
import CheckBoxViewModel from '@/ViewModels/Controls/CheckBoxViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import LabelViewModelBuilder from '@/Builder/LabelViewModelBuilder';
import ComponentManager from '@/Management/ComponentManager';

/**
 * Das ViewModel für die AssociationCheckBox
 */
export default class AssociationCheckBoxViewModel extends ControlViewModel {

    /**
     * Die wählbaren Optionen
     */
    public data: KnockoutObservableArray<CheckBoxViewModel>;

    /**
     * Die ausgewählten Werte
     */
    public values: KnockoutObservableArray<any>;

    /**
     * Ein Handler, der aufgerufen wird, wenn eine CheckBox angehakt wird
     */
    public onConnect: Function;

    /**
     * Ein Handler, der aufgerufen wird, wenn eine CheckBox abgehakt wird
     */
    public onDisconnect: Function;

    /**
     * Das ViewModel für das Label, falls kein selektierbares Item existiert
     */
    public label: LabelViewModel;

    /**
     * @param params {object} params - Ein Objekt mit Optionen für das Control
     */
    constructor(params: any) {
        super(params);
        this.data = this.observableOrDefault(params.data, []) as KnockoutObservableArray<CheckBoxViewModel>;
        this.values = this.observableOrDefault(params.values, []) as KnockoutObservableArray<any>;
        this.onConnect = this.handlerOrDefault(params.onConnect);
        this.onDisconnect = this.handlerOrDefault(params.onDisconnect);

        this.label = this.createLabel();

        this.defineComputed(() => {
            var values = this.values() || [];
            var data = this.data() || [];

            for (var i = 0; i < data.length; i++) {
                var checkBox = data[i];
                var checked = values.indexOf(checkBox.value.peek()) > -1;

                checkBox.isChecked(checked);
            }
        });
    }

    /**
     * Ein Handler zum Aufrufen der Handler onConnect und onDisconnect
     */
    public onChange(isChecked: boolean, value: any): JQueryPromise<any> {
        if (isChecked === true) {
            return this.evaluate(this.onConnect(value)).then((result) => {
                if (result) {
                    this.values.push(value);
                }

                return result;
            }).promise();
        } else {
            return this.evaluate(this.onDisconnect(value)).then((result) => {
                if (result) {
                    var index = this.values().indexOf(value);

                    if (index > -1) {
                        this.values.splice(index, 1);
                    }
                }

                return result;
            }).promise();
        }
    }

    protected createLabel(): LabelViewModel {
        return new LabelViewModelBuilder()
            .withIsVisible(this.defineComputed(() => this.data().length === 0))
            .withCaption('-')
            .build();
    }
}

ComponentManager.setViewModel('AssociationCheckBoxViewModel', AssociationCheckBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');